import { moduleRoute } from '@src/helper/routes'
import type { Router } from 'vue-router'

export default (router: Router) => {
    // Hidden route (not dependent on navigation items)
    router.addRoute(
        'Default',
        moduleRoute(
            'Sales',
            'ContractTemplateDocumentEditor',
            '/sales/contractTemplate/:id/document'
        )
    )

    router.addRoute('Default', {
        name: 'Sales@PostSalesTriggers',
        path: '/sales/contractTemplate/:contractTemplateId/postSalesTriggers',
        component: () => import('./views/PostSaleWorkflow/index.vue'),
        props: true,
    })

    router.addRoute(
        'Default',
        moduleRoute(
            'Sales',
            'ContractInstallments',
            '/sales/contract/:id/installments'
        )
    )

    // Public route — no authentication required
    router.addRoute(moduleRoute('Sales', 'ContractSign', '/sales/sign/:token'))
}
